// import { Courses } from "./courses";

export function toggleMobileMenu(ref: React.RefObject<HTMLElement>) {
  document.body.classList.toggle('mobile-nav-active');
  const classNames = ['bi-list', 'bi-x'];
  if (ref.current) {
    classNames.forEach(cls => ref.current?.classList.toggle(cls));
  }
}

export function toggleDropdown(e: React.MouseEvent<HTMLElement>, ref: React.RefObject<HTMLElement>) {
  e.preventDefault();
  e.stopPropagation();
  ref.current?.parentElement?.classList.toggle('active');
  ref.current?.parentElement?.nextElementSibling?.classList.toggle('dropdown-active');
}

export const hasMobileNavActive = (): boolean => {
  if (typeof document !== "undefined") {

    return document.body.classList.contains("mobile-nav-active");
  }
  return false;
};

// Commented out as it is not used in the current context - Loader should do this job!
// export async function getMenuItems() {
//   const response = await Courses.tags();
//   return {
//     props: { data: response }
//   };
// }

